/* esm.sh - @noble/curves@2.0.1/abstract/curve */
export * from "/*@noble/curves@2.0.1/esnext/abstract/curve.mjs";
